<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <contadores
      :total="contadores.total"
      :ativos="contadores.ativos"
      :inativos="contadores.inativos"
      @alterarFiltro="atualizarFiltro"
    />

    <v-card class="d-flex justify-space-between">
      <v-card-title>Canais</v-card-title>
      <v-btn
        v-if="!acessoPost"
        color="primary"
        class="ma-3"
        disabled
      >
        <span>Adicionar</span>
      </v-btn>

      <v-btn
        v-else
        color="primary"
        class="ma-3"
        @click="isAssociarCanalDialogOpen = !isAssociarCanalDialogOpen"
      >
        <span>Adicionar</span>
      </v-btn>

      <associar-canal-dialog
        :is-dialog-open.sync="isAssociarCanalDialogOpen"
        @refetch-data="$emit('refetch-data')"
      />
    </v-card>

    <div style="min-height: 4px">
      <v-progress-linear
        v-if="loading"
        indeterminate
      />
    </div>

    <table-canais-fila
      :headers="headers"
      :items="itemsFiltrados"
      @refetch-data="$emit('refetch-data')"
    />
  </v-card>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import { mapState } from 'pinia'
import AssociarCanalDialog from './AssociarCanalDialog.vue'
import TableCanaisFila from '@/components/tables/TableCanaisFila.vue'
import Contadores from '@/components/contadores/Contadores.vue'
import useAuthStore from '@/store/auth'

export default {
  components: {
    TableCanaisFila,
    AssociarCanalDialog,
    Contadores,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      idPost: 2010,
      acessoPost: true,
      idPut: 2011,
      acessoPut: true,
      idDisable: 2012,
      acessoDisable: true,
    }
  },

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
  },

  setup(props) {
    const isAssociarCanalDialogOpen = ref(false)
    const tiposDeCanaisAssociados = computed(() => props.items.map(i => i.canalTipoId))

    const filtroStatus = ref('true')
    const contadores = computed(() => ({
      total: props.items.length,
      ativos: props.items.filter(it => it.ativo).length,
      inativos: props.items.filter(it => !it.ativo).length,
    }))
    const itemsFiltrados = computed(() => (
      filtroStatus.value
        ? props.items.filter(it => it.ativo.toString() === filtroStatus.value)
        : props.items
    ))

    function atualizarFiltro(item) {
      filtroStatus.value = item
    }

    return {
      isAssociarCanalDialogOpen,
      tiposDeCanaisAssociados,
      contadores,
      itemsFiltrados,
      atualizarFiltro,
    }
  },
}
</script>
